export default __webpack_public_path__ + "static/media/57.e37b80be.png";